
import { useSelector } from 'react-redux';

const useUserAccessDetails = () => {

    const { accessDetails } = useSelector(state => state.auth);
    return accessDetails;
};

export default useUserAccessDetails;